module.exports = "https://web-assets.ifttt.com/packs/media/icons/google-play-store-174ecd10.svg";